import { Context } from 'access-control/Context.enum';
import { Role } from 'lib/types/role-type';
import { BusinessAccountMembership, UserProductItemRole, UserProductRole } from 'services';
import { ROLES_DICT } from './role.utils';

export const createAssigneeRoles = (
    membership: BusinessAccountMembership,
    userProductRole: UserProductRole | undefined,
    userProductItemRole: UserProductItemRole | undefined,
): Map<Context, Role> => {
    const assigneeRoles = new Map([[Context.BusinessAccount, ROLES_DICT[membership.role]]]);
    if (userProductRole) {
        assigneeRoles.set(Context.Product, ROLES_DICT[userProductRole.role]);
    }
    if (userProductItemRole) {
        assigneeRoles.set(Context.ProductItem, ROLES_DICT[userProductItemRole.role]);
    }
    return assigneeRoles;
};
